import { render, staticRenderFns } from "./DeliverOrdersOnBehalf1.vue?vue&type=template&id=6b151f02&scoped=true&"
import script from "./DeliverOrdersOnBehalf1.vue?vue&type=script&lang=js&"
export * from "./DeliverOrdersOnBehalf1.vue?vue&type=script&lang=js&"
import style0 from "./DeliverOrdersOnBehalf1.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DeliverOrdersOnBehalf1.vue?vue&type=style&index=1&id=6b151f02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b151f02",
  null
  
)

export default component.exports